import CipherTest from './CipherTest';

export default CipherTest;
